import { ICreateUser, IUpdateUser, IGetPaginatedUsers } from 'types';
import {
	serviceGetUserInfo,
	serviceCreateUser,
	serviceUpdateUser,
	serviceGetPaginatedUsers,
	serviceDeleteUser,
} from 'services/api/users';
import { createAppErrorMessage } from 'utils/helpers';

const getUserInfo = async (userID: string) => {
	try {
		const response = await serviceGetUserInfo(userID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createUser = async (data: ICreateUser) => {
	try {
		await serviceCreateUser(data);
	} catch (err) {
		throw err;
	}
};

const updateUser = async (data: IUpdateUser) => {
	try {
		await serviceUpdateUser(data);
	} catch (err) {
		throw err;
	}
};

const getPaginatedUsers = async (args: IGetPaginatedUsers) => {
	try {
		const response = await serviceGetPaginatedUsers(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteUser = async (userID: string) => {
	try {
		await serviceDeleteUser(userID);
	} catch (err) {
		const error = err as Error;
		const errorMessage = createAppErrorMessage(error, 'errorDeletingUser');
		throw new Error(errorMessage);
	}
};

export { getUserInfo, createUser, updateUser, getPaginatedUsers, deleteUser };
